import React, { useState, useRef, useEffect } from "react";
import "./styles/Chat.css";
import Message from "./Message";
import {
  addUserMessage,
  processUserMessage,
  addSystemMessage,
} from "../services";
import { setAuthToken, setWorkspace } from "../services/config";

function Chat({
  initialMessage,
  token = null,
  workspace = null,
  conversationId = null,
}) {
  const [messages, setMessages] = useState([
    {
      id: 1,
      text: initialMessage || "Olá! Como posso ajudar você hoje?",
      sender: "agent",
      timestamp: new Date(),
    },
  ]);

  const [newMessage, setNewMessage] = useState("");
  const [isTyping, setIsTyping] = useState(false);
  const messagesEndRef = useRef(null);
  const prevConversationIdRef = useRef(conversationId);
  const isFirstLoad = useRef(true);

  // Configurar o token e workspace quando o componente é montado ou quando mudam
  useEffect(() => {
    if (token) {
      setAuthToken(token);
    }

    if (workspace) {
      setWorkspace(workspace);
    }
  }, [token, workspace]);

  // Resetar as mensagens quando o conversationId mudar
  useEffect(() => {
    if (conversationId !== prevConversationIdRef.current) {
      // Não mostrar a mensagem de sistema na primeira carga
      if (!isFirstLoad.current && prevConversationIdRef.current !== null) {
        // Crie as mensagens iniciais
        const initialMessages = [
          {
            id: 1,
            text: initialMessage || "Olá! Como posso ajudar você hoje?",
            sender: "agent",
            timestamp: new Date(),
          },
        ];

        // Adicione a mensagem do sistema informando que uma nova conversa foi iniciada
        const messagesWithSystemInfo = addSystemMessage(
          "Nova conversa iniciada",
          initialMessages
        );

        setMessages(messagesWithSystemInfo);
      } else {
        // Primeira carga, apenas inicialize as mensagens sem a mensagem do sistema
        setMessages([
          {
            id: 1,
            text: initialMessage || "Olá! Como posso ajudar você hoje?",
            sender: "agent",
            timestamp: new Date(),
          },
        ]);
        isFirstLoad.current = false;
      }

      prevConversationIdRef.current = conversationId;
    }
  }, [conversationId, initialMessage]);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  const handleSendMessage = async (e) => {
    e.preventDefault();

    if (newMessage.trim() === "") return;

    const updatedMessages = addUserMessage(newMessage, messages);
    setMessages(updatedMessages);

    const messageText = newMessage;
    setNewMessage("");

    const result = await processUserMessage(
      messageText,
      updatedMessages,
      setIsTyping,
      conversationId
    );
    setMessages(result.messages);
  };

  return (
    <div className="chat-container">
      <div className="chat-messages">
        {messages.map((msg) => (
          <Message
            key={msg.id}
            text={msg.text}
            sender={msg.sender}
            timestamp={msg.timestamp}
          />
        ))}

        {isTyping && (
          <div className="typing-indicator">
            <span></span>
            <span></span>
            <span></span>
          </div>
        )}

        <div ref={messagesEndRef} />
      </div>

      <form className="chat-input-container" onSubmit={handleSendMessage}>
        <input
          type="text"
          value={newMessage}
          onChange={(e) => setNewMessage(e.target.value)}
          placeholder="Faça uma pergunta..."
          className="chat-input"
        />
        <button
          type="submit"
          className="send-button"
          disabled={newMessage.trim() === ""}
        >
          Enviar
        </button>
      </form>
    </div>
  );
}

export default Chat;
